export const SET_VALIDATION_ERRORS = "set_validation_errors"
export const REMOVE_VALIDATION_ERROR = "remove_validation_error"
export const CLEAR_VALIDATION_ERRORS = "clear_validation_errors"